const BRAZILIAN_PHONE_DIGIT_LIMIT = 11;

export const normalizeBrazilianPhoneNumber = (value = "") =>
  String(value)
    .replace(/\D/g, "")
    .replace(/^55(?=\d{10,})/, "")
    .slice(0, BRAZILIAN_PHONE_DIGIT_LIMIT);

export const formatBrazilianPhoneNumber = (value = "") => {
  const digits = normalizeBrazilianPhoneNumber(value);
  if (!digits) return "";

  if (digits.length <= 2) {
    return `(${digits}`;
  }

  const areaCode = digits.slice(0, 2);
  const localNumber = digits.slice(2);

  if (localNumber.length <= 4) {
    return `(${areaCode}) ${localNumber}`;
  }

  if (digits.length <= 10) {
    return `(${areaCode}) ${localNumber.slice(0, 4)}-${localNumber.slice(4)}`;
  }

  return `(${areaCode}) ${localNumber.slice(0, 5)}-${localNumber.slice(5)}`;
};
